import { memo } from 'react';

import { GetTripRes_stops } from '@/global-states/trip';
import { NewSocketMessageBus } from '@/socket';
import { getBusStopInfo, getTimeFormatFromUnix } from '@/utils/utils';

const EtaCard = ({
  tripStops,
  busList,
  variant,
}: {
  tripStops?: GetTripRes_stops[];
  busList?: NewSocketMessageBus;
  variant: 'card' | 'pill';
}) => {
  const destination = tripStops?.find((stop) => stop.is_destination);
  const info = destination
    ? getBusStopInfo(busList, destination?.target_id, destination?.stop_index)
    : undefined;

  if (!info?.etaMinute) return null;

  if (variant === 'pill') {
    return (
      <div className="flex items-center gap-2.5 rounded-full border border-ro-border-light bg-white py-2 pl-4 pr-3.5 shadow-pill">
        <div className="flex flex-col leading-none">
          <span className="text-[11px] font-semibold tracking-[0.03em] text-ro-muted">
            ARRIVING IN
          </span>
          <span className="mt-1 text-[19px] font-extrabold text-ro-black">
            {info.etaMinute} min
          </span>
        </div>
        <div className="h-[26px] w-px bg-ro-border" />
        <div className="flex flex-col leading-none">
          <span className="text-[11px] font-medium text-ro-stone">
            Est. arrival
          </span>
          <span className="mt-1 text-[13px] font-bold text-ro-black">
            {info.etaTimestamp ? getTimeFormatFromUnix(info.etaTimestamp) : ''}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="mb-3.5 flex items-center justify-between rounded-2xl border border-ro-border-light bg-ro-light-bg px-[18px] py-4">
      <div className="flex flex-col gap-1 leading-none">
        <span className="text-xs font-semibold tracking-[0.04em] text-ro-muted">
          ARRIVING IN
        </span>
        <span className="text-[32px] font-extrabold tracking-[-0.02em] text-ro-black">
          {info.etaMinute} min
        </span>
      </div>
      <div className="flex flex-col items-end gap-1.5">
        <span className="text-[12.5px] font-medium text-ro-stone">
          Est. arrival
        </span>
        <span className="text-base font-extrabold text-ro-black">
          {info.etaTimestamp ? getTimeFormatFromUnix(info.etaTimestamp) : ''}
        </span>
      </div>
    </div>
  );
};

export default memo(EtaCard);
